export enum EToken {
  TOKEN_JWT = 'tokenJWT',
  TOKEN_GOOGLE = 'tokenGoogle',
  TOKEN_FACEBOOK = 'tokenFacebook'
}


